import { assoc, reduce } from 'ramda'

/**
 * @type {Function}
 */
const offerLineIriUnitQuantityMapFactory = reduce(
  (carry, { offerLine, unitQuantity }) => assoc(offerLine, unitQuantity, carry),
  {},
)

export default offerLineIriUnitQuantityMapFactory
